module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_BinaryData_16"],"path":[{"$":{"d":"M3,7H1V3H0V1H3ZM3,9H0v2H1v4H3ZM15,1H12V3h1V7h2ZM8,9H5v2H6v4H8Zm2-8H5V7h5ZM7,3H8V5H7Zm8,6H10v6h5Zm-3,2h1v2H12Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_BinaryData_16.svg
// module id = Xqhf
// module chunks = 1